import {RootState} from '../../rootReducer';

export const getOnboardingState = (state: RootState) => state.data.onboarding;
